<template>
  <div>
    <div class="bar" v-if="res">
      <div class="w">
        <div class="text"><span> 下载股多多</span>·助您赢得投资第一桶金</div>
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd101/btn4.png"
          alt=""
        />
      </div>
    </div>
    <!-- <div class="bottomrs">
      <div class="text1">—— 投资有风险 入市需谨慎 ——</div> 
      <div class="text2" style="margin-top:10px">
        从事证券投资或期货交易，请通过合法证券期货经营机构进行
        合法机构名单可到中国证监会网站(www.csrc.gov.cn)查询
      </div>
      <div class="text2" style="margin-top:10px">
        公司：北京天相财富管理顾问有限公司
      </div>
      <div class="text2" style="margin-top:10px">
        业务资格许可证编号：91110102MA001GJE1N
      </div>
      <div class="text2" style="margin-top:10px">
        股多多软件版本号：v1.4.0.0 更新时间：2022年7月16日
      </div>
      <div class="text3" style="margin-top:15px">
        <span @click="open_yinsi()" style="margin-right: 15px;"
          >隐私保护政策</span
        >
        <span @click="open_fuwuxieyi()">软件服务协议</span>
      </div>
      <div class="text2" style="margin-top:10px">
        开发者名称:北京天相财富管理顾问有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
          href="https://beian.miit.gov.cn/#/Integrated/index"
        >
          京ICP备16068579号-1</a
        >
      </div>
    </div> -->
    <!-- <div class="boxx"></div> -->
    <!-- ------------------------------蒙层 -->
    <div class="divBG" v-if="tan" @click="tanss">
      <div class="content">
        <div class="tan">
          <div class="btnss">
            <img
              class="btn"
              @click="to_xaizai()"
              src="../../assets/img/pagess/gdd102/btn4.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="h1">
      <div class="w1">
        <div class="log">
          <img src="../../assets/img/pagess/gdd101/logo.png" alt="" />
        </div>
        <span>投资有风险 入市需谨慎</span>
      </div>
    </div>
    <div class="h2">
      <div class="w">
        <div class="l">
          <div class="li-1">证券分析软件</div>
          <div class="li-2">看盘·选股·更快一步！</div>
          <div class="li-2">
            <img
              class="btn"
              @click="to_xaizai()"
              src="../../assets/img/pagess/gdd101/btn1.png"
              alt=""
            />
          </div>
          <div class="li-4">1键下载 · 免费注册 · 终身使用</div>
        </div>
        <div class="r">
          <div class="li-1">
            <img src="../../assets/img/pagess/gdd101/h2-1.png" alt="" />
          </div>
          <div class="li-2">
            <img
              class="btn"
              @click="to_xaizai()"
              src="../../assets/img/pagess/gdd101/btn2.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="h3">
      <img src="../../assets/img/pagess/gdd101/h3.png" alt="" />
    </div>
    <div class="h4">
      <div class="w">
        <div class="li-1">
          全新四大 <span>炒股优选功能</span> 个股反转信号凸显
        </div>
        <div class="li-2">聚焦基本面、技术面、资金面、消息面四位一体更全面</div>
        <div class="li-3">
          <div class="lis1"></div>
          <div class="lis2"></div>
          <div class="lis3"></div>
          <div class="lis4"></div>
        </div>
        <div class="li-4">
          <img src="../../assets/img/pagess/gdd101/laba.png" alt="" />
          <span>今日风口已更新</span>
        </div>
        <div class="li-5">
          <img
            class="btn"
            @click="to_xaizai()"
            src="../../assets/img/pagess/gdd101/btn3.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="h5" ref="obtain">
      <div class="w1">
        <div class="text1">多维度 <span>监控强势股机会</span> 监测资金异动</div>
        <div class="text2">多空决策炒股系统，选股、买卖、仓位全方面建议</div>
      </div>
      <div class="w2">
        <div class="li-1">选股利器——六维共振：特色指标盘前甄选强势股</div>
        <div class="li-2">
          上证3500压力位行情反复震荡，哪些强势股会逆势上涨?
        </div>
        <div class="li-3">
          <div class="l">
            <img src="../../assets/img/pagess/gdd101/h5-2.png" alt="" />
          </div>
          <div class="r">
            <div class="lis1">选真龙 不惧调整</div>
            <div class="lis2">
              <img src="../../assets/img/pagess/gdd101/card.png" alt="" />
            </div>
            <div class="lis3">
              <div class="text1" style="padding-top:10px">风口提示</div>
              <div class="text2">无论上涨、震荡、下跌任何形态，</div>
              <div class="text2" style="padding-top:5px">
                实时捕捉当日强势股机会，辅助选股
              </div>
              <div class="text1" style="padding-top:10px">盘中直播</div>
              <div class="text2" style="padding-top:5px">
                专业解析盘面热点，缩小选股范围
              </div>
            </div>
          </div>
        </div>
        <div class="li-4">
          <img src="../../assets/img/pagess/gdd101/laba.png" alt="" />
          <span>今日风口已更新</span>
        </div>
        <div class="li-5 btn" @click="to_xaizai()">
          <img src="../../assets/img/pagess/gdd101/btn3.png" alt="" />
        </div>
      </div>
      <div class="w3">
        <div class="li-1">多空建议——动能二号：快速判断超短周期资金上攻强弱</div>
        <div class="li-2">
          一买就跌？一卖就涨？寻找强势股多空时机！
        </div>
        <div class="li-3">
          <div class="r">
            <div class="lis1">好股票 还需好操作</div>
            <div class="lis2">
              <img src="../../assets/img/pagess/gdd101/card.png" alt="" />
            </div>
            <div class="lis3">
              <div class="text1" style="padding-top:10px">操作讲纪律</div>
              <div class="text2">动能翻红，提示机会</div>
              <div class="text2" style="padding-top:5px">
                动能翻黄，警示风险
              </div>
              <div class="text1" style="padding-top:10px">离场预警</div>
              <div class="text2" style="padding-top:5px">
                洞悉资金动态，买卖快人一步
              </div>
            </div>
          </div>
          <div class="l">
            <img src="../../assets/img/pagess/gdd101/h5-4.png" alt="" />
          </div>
        </div>
        <div class="li-4">
          <img src="../../assets/img/pagess/gdd101/laba.png" alt="" />
          <span>今日风口已更新</span>
        </div>
        <div class="li-5 btn" @click="to_xaizai()">
          <img src="../../assets/img/pagess/gdd101/btn3.png" alt="" />
        </div>
      </div>
      <div class="w4">
        <div class="li-1">
          顺势调仓——擒龙环境：研判投资氛围，识别系统风险及机会
        </div>
        <div class="li-2">
          上证3500压力位行情反复震荡，哪些强势股会逆势上涨?
        </div>
        <div class="li-3">
          <div class="l">
            <img src="../../assets/img/pagess/gdd101/h5-5.png" alt="" />
          </div>
          <div class="r">
            <div class="lis1">选真龙 不惧调整</div>
            <div class="lis2">
              <img src="../../assets/img/pagess/gdd101/card.png" alt="" />
            </div>
            <div class="lis3">
              <div class="text1" style="padding-top:10px">大盘信号</div>
              <div class="text2" style="padding-top:5px">
                红色表示春天，波段上涨区域
              </div>
              <div class="text2" style="padding-top:5px">
                黄色表示夏天，横盘震荡区域
              </div>
              <div class="text2" style="padding-top:5px">
                绿色表示秋天，弱势下跌区域
              </div>
              <div class="text2" style="padding-top:5px">
                蓝色表示冬天，超跌反弹区域
              </div>

              <div class="text1" style="padding-top:10px">盘中直播</div>
              <div class="text2" style="padding-top:5px">
                从基本面、资金面、市场情绪、大盘
              </div>
              <div class="text2" style="padding-top:5px">
                走势4个方面定时更新仓位管理建议
              </div>
              <div class="text2">应对市场风险</div>
            </div>
          </div>
        </div>
        <div class="li-4">
          <img src="../../assets/img/pagess/gdd101/laba.png" alt="" />
          <span>今日风口已更新</span>
        </div>
        <div class="li-5 btn" @click="to_xaizai()">
          <img src="../../assets/img/pagess/gdd101/btn3.png" alt="" />
        </div>
      </div>
    </div>
    <div class="h6">
      <div class="w1">
        <div class="li-1">更多亮点，等你体验</div>
      </div>
      <div class="li-2">
        <div class="w">
          <div class="lis">
            <img src="../../assets/img/pagess/gdd101/1.png" alt="" />
            <span>实时股价预警</span>
            <span>操作快人一步</span>
          </div>
          <div class="lis">
            <img src="../../assets/img/pagess/gdd101/2.png" alt="" />
            <span>个股龙虎复盘</span>
            <span>识别主力动向</span>
          </div>
          <div class="lis">
            <img src="../../assets/img/pagess/gdd101/3.png" alt="" />
            <span>3分钟免费课</span>
            <span>实战选股更科学</span>
          </div>
          <div class="lis">
            <img src="../../assets/img/pagess/gdd101/4.png" alt="" />
            <span>执业优秀投顾坐镇</span>
            <span>尊享买方投教服务</span>
          </div>
        </div>
      </div>
      <div class="li-3">
        <div class="w">
          <div class="l">
            <img src="../../assets/img/pagess/gdd101/h6-1.png" alt="" />
          </div>
          <div class="r">
            <div class="lis1">
              <img src="../../assets/img/pagess/gdd101/h6-2.png" alt="" />
              <img src="../../assets/img/pagess/gdd101/h6-3.png" alt="" />
            </div>
            <div class="lis1">
              <img src="../../assets/img/pagess/gdd101/h6-4.png" alt="" />
              <img src="../../assets/img/pagess/gdd101/h6-5.png" alt="" />
              <img src="../../assets/img/pagess/gdd101/h6-6.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h7">
      <div class="w">
        <div class="text1">—— 投资有风险 入市需谨慎 ——</div>
        <div class="text2">
          从事证券投资或期货交易，请通过合法证券期货经营机构进行
          合法机构名单可到中国证监会网站(www.csrc.gov.cn)查询公司：北京天相财富管理顾问有限公司
        </div>

        <div class="text2">
          业务资格许可证编号：91110102MA001GJE1N
        </div>
        <div class="text2">
          股多多软件版本号：v1.4.0.0 更新时间：2022年7月16日
        </div>
        <div class="text2">
          <span @click="open_yinsi()" style="margin-right: 15px;"
            >隐私保护政策</span
          >
          <span @click="open_fuwuxieyi()">软件服务协议</span>
        </div>
        <div class="text2" style="margin-top:10px;">
          开发者名称:北京天相财富管理顾问有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            style="color: rgba(0, 145, 255, 1);"
          >
            京ICP备16068579号-1</a
          >
        </div>
      </div>
    </div>
    <div class="box"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      res: false,
      tan: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScrollx, true);
    this.clientIp();
    setTimeout(() => {
      this.tan = true;
    }, 15000);
  },
  methods: {
    tanss() {
      if (this.tan == true) {
        this.tan = false;
      } else {
        this.tan = true;
      }
    },
    handleScrollx() {
      if (this.$refs.obtain.getBoundingClientRect().top < 890) {
        this.res = true;
      } else {
        this.res = false;
      }
    },
    open_yinsi() {
      window.open("https://cdn.juniubang.com/apk/隐私政策4.7.pdf");
    },
    open_fuwuxieyi() {
      window.open("https://cdn.juniubang.com/apk/许可使用协议4.7.pdf");
    },
    changebar(index) {
      this.active = index;
    },
    to_xaizai() {
      this.post_leilei_data();
      // window.open("https://cdn.juniubang.com/apk/GDD2002.exe");
      this.tan = false;
    },
    // 给磊磊传页面数据
    post_leilei_data() {
      this.$http
        .post("/to_exe", {
          qhclickid: this.$route.query.sourceid,
          url: window.location.href,
          code: this.$route.query.code,
          type: "360"
        })
        .then(res => { window.open(res.data.message);});
    },

    clientIp() {
      this.$http.post("/client_ip", { url: window.location.href }).then(res => {
        window.localStorage.setItem("_number", res.data);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.divBG {
  z-index: 999;
  background-color: rgba(31, 30, 30, 0.6);
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 20;
  .content {
    width: 10px;
    margin: 0 auto;
    position: relative;
  }
  .tan {
    width: 620px;
    height: 412px;
    position: absolute;
    top: 50%;
    left: 50%;
    background: url(../../assets/img/pagess/gdd101/tan.png) no-repeat center;
    z-index: 999;
    margin: 206px 0 0 -310px;
    .btnss {
      padding-top: 355px;
      padding-left: 225px;
    }
  }
}

// .bottomrs {
//   width: 100%;
//   height: 338px;
//   text-align: center;
//   background: rgba(19, 31, 40, 1);
//   color: white;
//   .text1 {
//     font-size: 16px;
//     font-weight: 500;
//     padding-top: 50px;
//     text-align: center;
//   }
//   .text3 span {
//     color: #0091ff;
//     text-decoration: underline;
//   }
//   .text3 span:hover {
//     color: #f59504;
//   }
// }
.h1 {
  width: 100%;
  height: 70px;
  background-color: #fff;

  .w1 {
    width: 1200px;
    margin: 0 auto;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 17px;
      font-weight: 400;
      color: rgb(0, 0, 0);
    }
  }
}
.h2 {
  width: 100%;
  height: 620px;
  background: url(../../assets/img/pagess/gdd101/banner.png) no-repeat center;
  .w {
    margin: 0 auto;
    width: 1200px;
    height: 100%;
    display: flex;
    justify-content: center;
    .l {
      display: flex;
      flex-direction: column;
      align-items: center;
      .li-1 {
        padding-top: 120px;
        font-size: 105px;
        font-weight: 700;
        color: rgba(255, 255, 255, 1);
      }
      .li-2 {
        font-size: 32px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 42px;
      }
      .li-3 {
        margin-bottom: 38px;
      }
      .li-4 {
        font-size: 22px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
    .r {
      display: flex;
      flex-direction: column;
      align-items: center;
      .li-1 {
        padding-top: 90px;
        margin-bottom: 40px;
      }
    }
  }
}
.h3 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -79px;
}
.h4 {
  height: 589px;
  margin-top: 50px;
  .w {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      font-size: 36px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      margin-bottom: 15px;
      span {
        font-weight: 800;
        color: rgba(226, 40, 45, 1);
      }
    }
    .li-2 {
      font-size: 28px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin-bottom: 25px;
    }
    .li-3 {
      height: 285px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      margin-bottom: 46px;
      .lis1 {
        width: 273px;
        height: 236px;
        background: url(../../assets/img/pagess/gdd101/h4-1.png);
        background-size: 100% 100%;
      }
      .lis1:hover {
        width: 394px;
        height: 340px;
        background: url(../../assets/img/pagess/gdd101/h4-1-1.png);
        background-size: 100% 100%;
      }
      .lis2 {
        width: 273px;
        height: 236px;
        background: url(../../assets/img/pagess/gdd101/h4-2.png);
        background-size: 100% 100%;
      }
      .lis2:hover {
        width: 394px;
        height: 340px;
        background: url(../../assets/img/pagess/gdd101/h4-2-2.png);
        background-size: 100% 100%;
      }
      .lis3 {
        width: 273px;
        height: 236px;
        background: url(../../assets/img/pagess/gdd101/h4-3.png);
        background-size: 100% 100%;
      }
      .lis3:hover {
        width: 394px;
        height: 340px;
        background: url(../../assets/img/pagess/gdd101/h4-3-3.png);
        background-size: 100% 100%;
      }
      .lis4 {
        width: 273px;
        height: 236px;
        background: url(../../assets/img/pagess/gdd101/h4-4.png);
        background-size: 100% 100%;
      }
      .lis4:hover {
        width: 394px;
        height: 340px;
        background: url(../../assets/img/pagess/gdd101/h4-4.png);
        background-size: 100% 100%;
      }
    }
    .li-4 {
      display: flex;
      align-items: center;
      font-size: 28px;
      font-weight: 400;
      color: rgba(226, 40, 45, 1);
      margin-bottom: 20px;
      span {
        margin-left: 10px;
      }
    }
  }
}
.h5 {
  width: 100%;
  height: 2222px;
  background: rgba(0, 0, 0, 0.05);
  .w1 {
    margin: 0 auto;
    width: 100%;
    height: 128px;
    background: url(../../assets/img/pagess/gdd101/h5-1.png);
    display: flex;
    flex-direction: column;
    align-items: center;
    .text1 {
      padding-top: 18px;
      margin-bottom: 10px;
      font-size: 36px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      span {
        font-weight: 800;
      }
    }
    .text2 {
      font-size: 28px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
  .w2 {
    width: 1200px;
    margin: 0 auto;

    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 35px;
      margin-bottom: 5px;
      font-size: 28px;
      font-weight: 700;
      color: rgba(0, 0, 0, 1);
    }
    .li-2 {
      font-size: 25px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
    .li-3 {
      margin-top: 70px;
      display: flex;
      align-items: center;
      .r {
        width: 420px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 85px;
        .lis1 {
          font-size: 28px;
          font-weight: 400;
          color: rgba(226, 40, 45, 1);
        }
        .lis2 {
          margin-bottom: 15px;
        }
        .lis3 {
          width: 420px;
          height: 218px;
          background: url(../../assets/img/pagess/gdd101/h5-3.png);
          text-align: center;
          .text1 {
            font-size: 28px;
            font-weight: 700;
            color: rgba(0, 0, 0, 1);
          }
          .text2 {
            font-size: 24px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
          }
        }
      }
    }
    .li-4 {
      display: flex;
      align-items: center;
      font-size: 28px;
      font-weight: 400;
      color: rgba(226, 40, 45, 1);
      margin-bottom: 20px;
      margin-top: 50px;
      span {
        margin-left: 10px;
      }
    }
  }
  .w3 {
    width: 1200px;
    margin: 0 auto;

    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 35px;
      margin-bottom: 5px;
      font-size: 28px;
      font-weight: 700;
      color: rgba(0, 0, 0, 1);
    }
    .li-2 {
      font-size: 25px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
    .li-3 {
      margin-top: 70px;
      display: flex;
      align-items: center;
      .r {
        width: 420px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 148px;
        .lis1 {
          font-size: 28px;
          font-weight: 400;
          color: rgba(226, 40, 45, 1);
        }
        .lis2 {
          margin-bottom: 15px;
        }
        .lis3 {
          width: 420px;
          height: 218px;
          background: url(../../assets/img/pagess/gdd101/h5-3.png);
          text-align: center;
          .text1 {
            font-size: 28px;
            font-weight: 700;
            color: rgba(0, 0, 0, 1);
          }
          .text2 {
            font-size: 24px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
          }
        }
      }
    }
    .li-4 {
      display: flex;
      align-items: center;
      font-size: 28px;
      font-weight: 400;
      color: rgba(226, 40, 45, 1);
      margin-bottom: 20px;
      margin-top: 50px;
      span {
        margin-left: 10px;
      }
    }
  }
  .w4 {
    width: 1200px;
    margin: 0 auto;

    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 35px;
      margin-bottom: 5px;
      font-size: 28px;
      font-weight: 700;
      color: rgba(0, 0, 0, 1);
    }
    .li-2 {
      font-size: 25px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
    .li-3 {
      margin-top: 50px;
      display: flex;
      align-items: center;
      .r {
        width: 420px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 85px;
        .lis1 {
          font-size: 28px;
          font-weight: 400;
          color: rgba(226, 40, 45, 1);
        }
        .lis2 {
          margin-bottom: 15px;
        }
        .lis3 {
          width: 420px;
          height: 367px;
          background: url(../../assets/img/pagess/gdd101/h5-6.png);
          text-align: center;
          .text1 {
            font-size: 28px;
            font-weight: 700;
            color: rgba(0, 0, 0, 1);
          }
          .text2 {
            font-size: 24px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
          }
        }
      }
    }
    .li-4 {
      display: flex;
      align-items: center;
      font-size: 28px;
      font-weight: 400;
      color: rgba(226, 40, 45, 1);
      margin-bottom: 20px;
      margin-top: 50px;
      span {
        margin-left: 10px;
      }
    }
  }
}
.h6 {
  .w1 {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      font-size: 36px;
      font-weight: 700;
      color: rgba(226, 40, 45, 1);
      padding-top: 50px;
      margin-bottom: 50px;
    }
  }
  .li-2 {
    margin: 0 auto;
    width: 100%;
    height: 232px;
    background: url(../../assets/img/pagess/gdd101/h5-1.png) no-repeat center;
    .w {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      justify-content: space-evenly;
      .lis {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 20px;
        img {
          margin-bottom: 12px;
        }
        span {
          font-size: 28px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
  }
  .li-3 {
    padding-top: 40px;
    .w {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .r {
        height: 666px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .lis1 {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }
  }
}
.bar {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 184px;
  background: url(../../assets/img/pagess/gdd101/bar.png) no-repeat center;
  z-index: 998;
  .w {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    img {
      right: 10px;
      top: -55px;
      position: absolute;
    }
    .text {
      height: 184px;
      line-height: 184px;
      font-size: 50px;
      font-weight: 700;
      color: rgba(255, 255, 255, 1);
      span {
        font-weight: 400;
      }
    }
  }
}
.h7 {
  width: 100%;
  height: 279px;
  .w {
    margin: 0 auto;
    width: 1200px;
    height: 100%;
    text-align: center;
    .text1 {
      padding-top: 50px;
      font-size: 12px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 15px;
    }
    .text2 {
      font-size: 12px;
      font-weight: 400;
      line-height: 21px;
      color: rgba(51, 51, 51, 1);
      span {
        text-decoration: underline;
        color: rgba(0, 145, 255, 1);
      }
    }
  }
}
.box {
  width: 100%;
  height: 170px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/pagess/gdd153.vue